(function () {
  'use strict';

  var root = document.querySelector('[data-dw-wishlist-root]');
  if (!root || !document.body.classList.contains('template-product')) return;

  var layer = root.querySelector('[data-dw-wishlist-layer]');
  var drawer = root.querySelector('[data-dw-wishlist-drawer]');
  var itemList = root.querySelector('[data-dw-wishlist-items]');
  var emptyState = root.querySelector('[data-dw-wishlist-empty]');
  var drawerCount = root.querySelector('[data-dw-wishlist-drawer-count]');
  var clearButton = root.querySelector('[data-dw-wishlist-clear]');
  var memberAccess = root.querySelector('[data-dw-wishlist-member-access]');
  var toast = root.querySelector('[data-dw-wishlist-toast]');
  var toastMessage = root.querySelector('[data-dw-wishlist-toast-message]');
  var toastView = root.querySelector('[data-dw-wishlist-toast-view]');
  var storagePrefix = 'dw:wishlist:v1:';
  var customerScope = root.dataset.dwWishlistCustomerKey || 'guest';
  var storageKey = storagePrefix + customerScope;
  var guestStorageKey = storagePrefix + 'guest';
  var memoryStore = {};
  var maxItems = 50;
  var pricingMode = root.dataset.dwWishlistPricingMode === 'open_sale' ? 'open_sale' : 'members';
  var loggedIn = root.dataset.dwWishlistLoggedIn === 'true';
  var wishlistLabels = {
    member: root.dataset.dwWishlistMemberLabel || 'MEMBERS',
    sale: root.dataset.dwWishlistSaleLabel || 'SALE',
    clearance: root.dataset.dwWishlistClearanceLabel || 'CLEARANCE'
  };
  var refreshLifetime = 15 * 60 * 1000;
  var items = [];
  var previousFocus = null;
  var toastTimer = 0;
  var topFrame = 0;
  var refreshRequest = null;
  var removeMarkup = [
    '<svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 64 64">',
    '<path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path>',
    '</svg>'
  ].join('');

  function toString(value) {
    return value === null || typeof value === 'undefined' ? '' : String(value);
  }

  function setAttribute(element, name, value) {
    value = toString(value);
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function setData(element, name, value) {
    value = toString(value);
    if (element.dataset[name] !== value) element.dataset[name] = value;
  }

  function setText(element, value) {
    value = toString(value);
    if (element.textContent !== value) element.textContent = value;
  }

  function setHidden(element, hidden) {
    if (element.hidden !== hidden) element.hidden = hidden;
  }

  function toBoolean(value) {
    return value !== false && value !== 'false' && value !== '0';
  }

  function isTrue(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function safeRead(key) {
    var value;

    try {
      value = window.localStorage.getItem(key);
    } catch (error) {
      value = memoryStore[key] || '';
    }

    if (!value) return [];

    try {
      return JSON.parse(value);
    } catch (error) {
      return [];
    }
  }

  function safeWrite(key, value) {
    var json = JSON.stringify(value);

    memoryStore[key] = json;
    try {
      window.localStorage.setItem(key, json);
    } catch (error) {
      // Private browsing and strict storage policies still get page-session support.
    }
  }

  function safeRemove(key) {
    delete memoryStore[key];
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // Storage can be unavailable without preventing the wishlist from working.
    }
  }

  function normalizeUrl(value) {
    if (!value) return '';

    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.href;
    } catch (error) {
      return value;
    }
  }

  function handleFromUrl(value) {
    if (!value) return '';

    try {
      var pathname = new URL(value, window.location.origin).pathname;
      var match = pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function sanitizeItem(item) {
    if (!item || typeof item !== 'object') return null;

    var productId = toString(item.productId || item.product_id);
    var handle = toString(item.handle || handleFromUrl(item.url));
    var productKey = toString(item.productKey || item.key || productId || handle);
    if (!productKey || !toString(item.title)) return null;

    return {
      productKey: productKey,
      productId: productId,
      variantId: toString(item.variantId || item.variant_id),
      handle: handle,
      title: toString(item.title),
      vendor: toString(item.vendor),
      url: normalizeUrl(item.url || (handle ? '/products/' + handle : '')),
      image: toString(item.image),
      priceCents: Number(item.priceCents) || 0,
      priceLabel: toString(item.priceLabel),
      compareCents: Number(item.compareCents) || 0,
      compareLabel: toString(item.compareLabel),
      variantTitle: toString(item.variantTitle),
      available: toBoolean(item.available),
      clearance: isTrue(item.clearance),
      source: toString(item.source),
      savedAt: Number(item.savedAt) || Date.now(),
      verifiedAt: Number(item.verifiedAt) || 0,
      pricingMode: item.pricingMode === 'open_sale' ? 'open_sale' : 'members'
    };
  }

  function sanitizeItems(rawItems) {
    var seen = {};

    return (Array.isArray(rawItems) ? rawItems : [])
      .map(sanitizeItem)
      .filter(function (item) {
        if (!item || seen[item.productKey]) return false;
        seen[item.productKey] = true;
        return true;
      })
      .sort(function (a, b) { return b.savedAt - a.savedAt; })
      .slice(0, maxItems);
  }

  function mergeGuestItems() {
    if (customerScope === 'guest') return sanitizeItems(safeRead(storageKey));

    var customerItems = sanitizeItems(safeRead(storageKey));
    var guestItems = sanitizeItems(safeRead(guestStorageKey));
    if (!guestItems.length) return customerItems;

    var merged = sanitizeItems(customerItems.concat(guestItems));
    safeWrite(storageKey, merged);
    safeRemove(guestStorageKey);
    return merged;
  }

  function itemIndex(productKey) {
    return items.findIndex(function (item) {
      return item.productKey === toString(productKey);
    });
  }

  function isSaved(productKey) {
    return itemIndex(productKey) > -1;
  }

  function formatMoney(cents) {
    if (!Number.isFinite(Number(cents))) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Number(cents), window.theme && window.theme.settings && window.theme.settings.moneyFormat);
    }

    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD'
    }).format(Number(cents) / 100);
  }

  function itemFromButton(button) {
    var data = button.dataset;
    var productKey = data.dwWishlistProductKey || data.dwWishlistProductId || data.dwWishlistHandle;
    if (!productKey || !data.dwWishlistTitle) return null;

    return sanitizeItem({
      productKey: productKey,
      productId: data.dwWishlistProductId,
      variantId: data.dwWishlistVariantId,
      handle: data.dwWishlistHandle,
      title: data.dwWishlistTitle,
      vendor: data.dwWishlistVendor,
      url: data.dwWishlistUrl,
      image: data.dwWishlistImage,
      priceCents: data.dwWishlistPriceCents,
      priceLabel: data.dwWishlistPriceLabel,
      compareCents: data.dwWishlistCompareCents,
      compareLabel: data.dwWishlistCompareLabel,
      variantTitle: data.dwWishlistVariantTitle,
      available: data.dwWishlistAvailable,
      clearance: data.dwWishlistClearance,
      source: data.dwWishlistSource,
      savedAt: Date.now(),
      verifiedAt: Date.now(),
      pricingMode: pricingMode
    });
  }

  function setButtonState(button) {
    var productKey = button.dataset.dwWishlistProductKey;
    var saved = isSaved(productKey);
    var title = button.dataset.dwWishlistTitle || 'this item';
    var label = button.querySelector('.dw-wishlist-button__label');
    var defaultLabel = button.dataset.dwWishlistDefaultLabel || 'Save item';
    var savedLabel = button.dataset.dwWishlistSavedLabel || 'Saved';

    setAttribute(button, 'aria-pressed', saved ? 'true' : 'false');
    setAttribute(button, 'aria-label', (saved ? 'Remove ' : 'Save ') + title + (saved ? ' from saved items' : ''));
    if (label) setText(label, saved ? savedLabel : defaultLabel);
  }

  function syncControls() {
    document.querySelectorAll('[data-dw-wishlist-button]').forEach(setButtonState);

    document.querySelectorAll('[data-dw-wishlist-count]').forEach(function (count) {
      setText(count, items.length > 99 ? '99+' : String(items.length));
      setHidden(count, items.length === 0);
    });

    document.querySelectorAll('[data-dw-wishlist-trigger]').forEach(function (trigger) {
      setData(trigger, 'dwWishlistHasItems', items.length ? 'true' : 'false');
    });

    setText(drawerCount, items.length ? String(items.length) : '');
    setHidden(clearButton, items.length === 0);
  }

  function appendText(parent, tag, className, value) {
    if (!value) return null;
    var element = document.createElement(tag);
    element.className = className;
    element.textContent = value;
    parent.appendChild(element);
    return element;
  }

  function isDiscountedItem(item) {
    var price = Number(item.priceCents) || Math.round(Number(String(item.priceLabel || '').replace(/[^0-9.]/g, '')) * 100);
    var compare = Number(item.compareCents) || Math.round(Number(String(item.compareLabel || '').replace(/[^0-9.]/g, '')) * 100);
    return price > 0 && compare > price && (compare - price) * 100 >= compare * 2;
  }

  function wishlistPriceState(item) {
    if (item.clearance) {
      return { label: wishlistLabels.clearance, tone: 'clearance', requiresLogin: false };
    }

    if (!isDiscountedItem(item)) {
      return { label: '', tone: 'regular', requiresLogin: false };
    }

    if (pricingMode === 'open_sale') {
      return { label: wishlistLabels.sale, tone: 'sale', requiresLogin: false };
    }

    return { label: wishlistLabels.member, tone: 'member', requiresLogin: !loggedIn };
  }

  function wishlistNeedsMemberAccess() {
    return items.some(function (item) {
      return wishlistPriceState(item).requiresLogin;
    });
  }

  function createItemRow(item) {
    var row = document.createElement('li');
    var imageLink = document.createElement('a');
    var content = document.createElement('div');
    var titleLink = document.createElement('a');
    var pricing = document.createElement('div');
    var priceState = wishlistPriceState(item);
    var viewLink = document.createElement('a');
    var removeButton = document.createElement('button');

    row.className = 'dw-wishlist-item';
    row.dataset.dwWishlistItem = item.productKey;

    imageLink.className = 'dw-wishlist-item__image-link';
    imageLink.href = item.url || '#';
    imageLink.setAttribute('aria-label', 'View ' + item.title);

    if (item.image) {
      var image = document.createElement('img');
      image.className = 'dw-wishlist-item__image';
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      imageLink.appendChild(image);
    } else {
      appendText(imageLink, 'span', 'dw-wishlist-item__no-image', 'No image');
    }

    row.appendChild(imageLink);

    content.className = 'dw-wishlist-item__content';
    appendText(content, 'span', 'dw-wishlist-item__vendor', item.vendor);

    titleLink.className = 'dw-wishlist-item__title';
    titleLink.href = item.url || '#';
    titleLink.textContent = item.title;
    content.appendChild(titleLink);

    if (item.variantTitle && item.variantTitle !== 'Default Title' && item.variantTitle !== 'Regular') {
      appendText(content, 'span', 'dw-wishlist-item__variant', item.variantTitle);
    }

    pricing.className = 'dw-wishlist-item__pricing';
    if (isDiscountedItem(item) || item.clearance) appendText(pricing, 'span', 'dw-wishlist-item__compare', item.compareLabel);

    var currentRow = document.createElement('span');
    currentRow.className = 'dw-wishlist-item__current-row dw-wishlist-item__current-row--' + priceState.tone;
    if (priceState.label) {
      appendText(
        currentRow,
        'span',
        'dw-wishlist-item__price-label dw-wishlist-item__price-label--' + priceState.tone,
        priceState.label
      );
    }
    var price = appendText(currentRow, 'span', 'dw-wishlist-item__price', item.priceLabel || formatMoney(item.priceCents));
    if (price && priceState.tone !== 'regular') {
      price.classList.add('dw-wishlist-item__price--campaign', 'dw-wishlist-item__price--' + priceState.tone);
    }
    if (currentRow.childNodes.length) pricing.appendChild(currentRow);
    if (pricing.childNodes.length) content.appendChild(pricing);

    if (!item.available) {
      appendText(content, 'span', 'dw-wishlist-item__unavailable', 'Currently unavailable');
    }

    viewLink.className = 'dw-wishlist-item__view';
    viewLink.href = item.url || '#';
    viewLink.textContent = 'View product';
    content.appendChild(viewLink);
    row.appendChild(content);

    removeButton.type = 'button';
    removeButton.className = 'dw-wishlist-item__remove';
    removeButton.dataset.dwWishlistRemove = item.productKey;
    removeButton.setAttribute('aria-label', 'Remove ' + item.title + ' from saved items');
    removeButton.innerHTML = removeMarkup;
    row.appendChild(removeButton);

    return row;
  }

  function renderDrawer() {
    if (!layer.classList.contains('is-open')) return;
    var fragment = document.createDocumentFragment();
    itemList.textContent = '';

    items.forEach(function (item) {
      fragment.appendChild(createItemRow(item));
    });

    itemList.appendChild(fragment);
    itemList.hidden = items.length === 0;
    emptyState.hidden = items.length > 0;
    if (memberAccess) memberAccess.hidden = !wishlistNeedsMemberAccess();
  }

  function dispatchChange(action, item) {
    document.dispatchEvent(new CustomEvent('dw:wishlist-change', {
      detail: {
        action: action,
        item: item || null,
        items: items.slice(),
        count: items.length
      }
    }));
  }

  function persist(action, changedItem) {
    items = sanitizeItems(items);
    safeWrite(storageKey, items);
    syncControls();
    renderDrawer();
    dispatchChange(action, changedItem);
  }

  function trackAdd(item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: 'NZD',
        value: item.priceCents ? item.priceCents / 100 : undefined,
        items: [{
          item_id: item.variantId || item.productId,
          item_name: item.title,
          item_brand: item.vendor,
          item_variant: item.variantTitle,
          price: item.priceCents ? item.priceCents / 100 : undefined,
          quantity: 1
        }]
      }
    });
  }

  function showToast(message) {
    window.clearTimeout(toastTimer);
    toastMessage.textContent = message;
    toast.hidden = false;
    toastTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, 3500);
  }

  function addItem(item) {
    if (!item) return;
    items = items.filter(function (savedItem) {
      return savedItem.productKey !== item.productKey;
    });
    items.unshift(item);
    persist('add', item);
    trackAdd(item);
    showToast('Saved ' + item.title);
  }

  function removeItem(productKey, showMessage) {
    var index = itemIndex(productKey);
    if (index < 0) return;

    var removed = items[index];
    items.splice(index, 1);
    persist('remove', removed);
    if (showMessage) showToast('Removed ' + removed.title);
  }

  function toggleItem(button) {
    var item = itemFromButton(button);
    if (!item) return;

    if (isSaved(item.productKey)) {
      removeItem(item.productKey, true);
    } else {
      addItem(item);
    }
  }

  function updateSavedItem(button) {
    var nextItem = itemFromButton(button);
    var index = nextItem ? itemIndex(nextItem.productKey) : -1;
    if (index < 0) return;

    nextItem.savedAt = items[index].savedAt;
    items[index] = nextItem;
    persist('update', nextItem);
  }

  function storefrontRoot() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    rootPath = rootPath || '/';
    return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
  }

  function wishlistDataUrl(item) {
    var url = storefrontRoot() + 'products/' + encodeURIComponent(item.handle) + '?view=dw-card-data';
    if (item.variantId) url += '&variant=' + encodeURIComponent(item.variantId);
    return url;
  }

  function refreshedItem(markup, originalItem) {
    if (!markup) return null;

    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var data = parsed.querySelector('[data-dw-product-card-data]');
    if (!data) return null;

    var refreshedVariantId = data.getAttribute('data-product-variant-id') || originalItem.variantId;
    if (originalItem.variantId && refreshedVariantId && toString(originalItem.variantId) !== toString(refreshedVariantId)) {
      return null;
    }

    return sanitizeItem({
      productKey: originalItem.productKey,
      productId: data.getAttribute('data-product-id') || originalItem.productId,
      variantId: refreshedVariantId,
      handle: data.getAttribute('data-product-handle') || originalItem.handle,
      title: data.getAttribute('data-product-title') || originalItem.title,
      vendor: data.getAttribute('data-product-vendor') || originalItem.vendor,
      url: data.getAttribute('data-product-url') || originalItem.url,
      image: data.getAttribute('data-product-image') || originalItem.image,
      priceCents: data.getAttribute('data-product-price-cents'),
      priceLabel: data.getAttribute('data-product-price-label'),
      compareCents: data.getAttribute('data-product-compare-cents'),
      compareLabel: data.getAttribute('data-product-compare-label'),
      variantTitle: data.getAttribute('data-product-variant-title') || originalItem.variantTitle,
      available: data.getAttribute('data-product-available'),
      clearance: data.getAttribute('data-product-clearance'),
      source: originalItem.source,
      savedAt: originalItem.savedAt,
      verifiedAt: Date.now(),
      pricingMode: pricingMode
    });
  }

  function refreshSavedItem(item) {
    if (!item.handle) return Promise.resolve(null);

    return fetch(wishlistDataUrl(item), { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (markup) { return refreshedItem(markup, item); })
      .catch(function () { return null; });
  }

  function refreshSavedItems() {
    if (refreshRequest) return refreshRequest;

    var now = Date.now();
    var queue = items.filter(function (item) {
      return item.handle && (
        item.pricingMode !== pricingMode ||
        !item.verifiedAt ||
        now - item.verifiedAt > refreshLifetime
      );
    });

    if (!queue.length) return Promise.resolve();

    var changed = false;
    var workers = [];
    var workerCount = Math.min(4, queue.length);

    function work() {
      var originalItem = queue.shift();
      if (!originalItem) return Promise.resolve();

      return refreshSavedItem(originalItem).then(function (nextItem) {
        var index = itemIndex(originalItem.productKey);
        if (
          nextItem &&
          index > -1 &&
          toString(items[index].variantId) === toString(originalItem.variantId)
        ) {
          nextItem.savedAt = items[index].savedAt;
          items[index] = nextItem;
          changed = true;
        }
      }).then(work);
    }

    for (var index = 0; index < workerCount; index += 1) {
      workers.push(work());
    }

    refreshRequest = Promise.all(workers).then(function () {
      if (!changed) return;
      items = sanitizeItems(items);
      safeWrite(storageKey, items);
      syncControls();
      renderDrawer();
      dispatchChange('refresh', null);
    }).then(function () {
      refreshRequest = null;
    }, function () {
      refreshRequest = null;
    });

    return refreshRequest;
  }

  function setDrawerTop() {
    topFrame = 0;
    var header = document.getElementById('SiteHeader');
    var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    var mobilePanelTop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dw-mobile-panel-top')) || 0;
    var top = Math.max(0, Math.min(window.innerHeight, headerBottom));

    if (window.innerWidth <= 768) top = Math.max(top, mobilePanelTop);
    document.documentElement.style.setProperty('--dw-wishlist-top', Math.round(top) + 'px');
  }

  function scheduleDrawerTop() {
    if (topFrame || !layer.classList.contains('is-open')) return;
    topFrame = window.requestAnimationFrame(setDrawerTop);
  }

  function focusableElements() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]):not([hidden]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) { return element.getClientRects().length > 0; }
    );
  }

  function focusDrawer() {
    if (!layer.classList.contains('is-open')) return;

    var closeButton = drawer.querySelector('.dw-wishlist-drawer__close');
    var target = closeButton || drawer;

    try {
      target.focus({ preventScroll: true });
    } catch (error) {
      target.focus();
    }
  }

  function openDrawer(trigger) {
    previousFocus = trigger || document.activeElement;
    setDrawerTop();
    layer.classList.add('is-open');
    layer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dw-wishlist-open');
    document.querySelectorAll('[data-dw-wishlist-trigger]').forEach(function (item) {
      item.setAttribute('aria-expanded', 'true');
    });
    renderDrawer();
    refreshSavedItems();
    window.requestAnimationFrame(focusDrawer);
    window.setTimeout(focusDrawer, 120);
  }

  function closeDrawer() {
    if (!layer.classList.contains('is-open')) return;

    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dw-wishlist-open');
    document.querySelectorAll('[data-dw-wishlist-trigger]').forEach(function (item) {
      item.setAttribute('aria-expanded', 'false');
    });

    var restoreTarget = previousFocus && previousFocus.getClientRects().length
      ? previousFocus
      : document.querySelector('.js-drawer-open-nav, .site-nav__link--wishlist');
    if (restoreTarget && restoreTarget.getClientRects().length) restoreTarget.focus();
    previousFocus = null;
  }

  function openFromTrigger(trigger) {
    var navDrawer = document.getElementById('NavDrawer');

    if (navDrawer && navDrawer.contains(trigger) && window.theme && window.theme.NavDrawer && window.theme.NavDrawer.isOpen) {
      window.theme.NavDrawer.activeSource = null;
      window.theme.NavDrawer.close();
      window.setTimeout(function () { openDrawer(trigger); }, 30);
      return;
    }

    openDrawer(trigger);
  }

  function onKeydown(event) {
    if (!layer.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function imageValue(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || value.originalSrc || value.image || '';
  }

  function updateVariantButtons(variant, scope) {
    if (!variant) return;

    // Sync both responsive controls, but never another product's quick view.
    var buttons = scope.querySelectorAll('.dw-wishlist-button--pdp, .dw-wishlist-button--pdp-action');

    Array.prototype.forEach.call(buttons, function (button) {
      var url;
      try {
        url = new URL(button.dataset.dwWishlistUrl || window.location.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
      } catch (error) {
        url = null;
      }

      setData(button, 'dwWishlistVariantId', variant.id || '');
      setData(button, 'dwWishlistVariantTitle', variant.title || '');
      setData(button, 'dwWishlistAvailable', variant.available === false ? 'false' : 'true');
      setData(button, 'dwWishlistPriceCents', variant.price || 0);
      setData(button, 'dwWishlistPriceLabel', formatMoney(variant.price || 0));
      setData(button, 'dwWishlistCompareCents', variant.compare_at_price || 0);
      setData(button, 'dwWishlistCompareLabel', variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '');
      if (url) setData(button, 'dwWishlistUrl', normalizeUrl(url.href));

      var image = imageValue(variant.featured_image || variant.featured_media);
      if (image) setData(button, 'dwWishlistImage', image);
      setButtonState(button);
    });

    if (buttons.length) updateSavedItem(buttons[0]);
  }

  document.addEventListener('click', function (event) {
    var saveButton = event.target.closest('[data-dw-wishlist-button]');
    if (saveButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(saveButton);
      return;
    }

    var trigger = event.target.closest('[data-dw-wishlist-trigger]');
    if (trigger) {
      event.preventDefault();
      openFromTrigger(trigger);
      return;
    }

    var removeButton = event.target.closest('[data-dw-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      removeItem(removeButton.dataset.dwWishlistRemove, false);
      return;
    }

    if (event.target.closest('[data-dw-wishlist-clear]')) {
      event.preventDefault();
      items = [];
      persist('clear', null);
      return;
    }

    if (event.target.closest('[data-dw-wishlist-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.target.closest('[data-dw-wishlist-toast-view]')) {
      event.preventDefault();
      toast.hidden = true;
      openDrawer(event.target.closest('[data-dw-wishlist-toast-view]'));
    }
  }, true);

  document.addEventListener('variantChange', function (event) {
    updateVariantButtons(event.detail && event.detail.variant, event.target);
  }, true);

  document.addEventListener('keydown', onKeydown);
  window.addEventListener('resize', scheduleDrawerTop);
  window.addEventListener('scroll', scheduleDrawerTop, { passive: true });
  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey) return;
    items = sanitizeItems(safeRead(storageKey));
    syncControls();
    renderDrawer();
  });

  document.addEventListener('shopify:section:load', syncControls);

  items = mergeGuestItems();
  syncControls();
  renderDrawer();
}());

